import { render, staticRenderFns } from "./BuyerCard.vue?vue&type=template&id=9ca89566&"
import script from "./BuyerCard.vue?vue&type=script&lang=ts&"
export * from "./BuyerCard.vue?vue&type=script&lang=ts&"
import style0 from "./BuyerCard.vue?vue&type=style&index=0&id=9ca89566&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports